import styled, { css } from 'styled-components';
import { ScOptionsProps } from '../../types';

export const ScProfileOptions = styled.div<ScOptionsProps>`
  position: absolute;
  left: 50%;
  right: 0;
  transform: translateX(-50%);
  background-color: ${({ theme, lightBg }) =>
    lightBg ? theme.grayColor5 : theme.grayColor4};
  border-radius: 4px;
  overflow: hidden;
  width: 100%;

  & > .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  & > .border {
    position: absolute;
    z-index: 1;
    inset: 0;
    border-radius: 12px;
    padding: 2px;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: ${({ theme }) => theme.greenMarineGradient};
    }
  }

  top: 56px;
  border-radius: 12px;
  padding: 2px 8px;

  & > .content {
    z-index: 2;
    position: relative;
  }

  & > .border {
    position: absolute;
    z-index: 1;
    inset: 0;
    border-radius: 12px;
    padding: 2px;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: ${({ theme }) => theme.greenMarineGradient};
    }
  }

  ${({ paddingTop }) =>
    paddingTop &&
    css`
      padding-top: 36px;
    `}

  .ScrollbarsCustom {
    .scrollbarsWrapper {
      inset: 0 !important;
    }

    .trackY {
      width: 4px !important;
      border-radius: 2px !important;
      background: none !important;
      top: 6px !important;
      height: calc(100% - 12px) !important;
      right: -1px !important;

      & > div {
        width: 4px !important;
        background: ${({ theme }) => theme.grayColor6} !important;
        border-radius: 2px !important;
        transition: 0.3s;

        @media (hover: hover) {
          &.dragging {
            background: ${({ theme }) => theme.grayColor1} !important;
          }

          &:hover {
            background: ${({ theme }) => theme.grayColor1} !important;
          }
        }
      }
    }
  }

  .options-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    list-style: none;
    padding: 6px 8px 6px 0;

    & > li {
      width: 100%;
      padding: 4px 8px;
      cursor: pointer;
      background-color: transparent;
      display: flex;
      align-items: center;
      border-radius: 8px;
      color: ${({ theme }) => theme.grayColor1};
      &.not-found {
        text-align: center;
        font-size: 12px;
      }

      &.with-icon {
        gap: 8px;

        img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          object-fit: contain;
        }
      }

      & > .name {
        transition: color 0.2s;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 20px;
      }

      &.active {
        color: ${({ theme }) => theme.whiteColor};
        background: ${({ theme, lightBg }) =>
          lightBg ? theme.grayColor4 : theme.grayColor5};
        border-radius: 8px;
      }

      &.active,
      &:hover {
        color: ${({ theme }) => theme.whiteColor};
      }
    }
  }

  .content > .addons {
    & > button {
      min-width: 100%;
    }
  }
`;
